import React, { useState } from "react";
import CardContext from "./card-context";

const CardProvider = (props) => {
  const [cardDetails, setCardDetails] = useState({});
  const [token, setToken] = useState("");
  const [isDeclined, setIsDeclined] = useState(false);

  const updateCardDetails = (newDetails) => {
    setCardDetails((prevDetails) => ({
      ...prevDetails,
      ...newDetails,
    }));
  };
  return (
    <CardContext.Provider
      value={{
        cardDetails,
        setCardDetails,
        updateCardDetails,
        token,
        setToken,
        isDeclined,
        setIsDeclined,
      }}
    >
      {props.children}
    </CardContext.Provider>
  );
};

export default CardProvider;
